import { render, staticRenderFns } from "./info_serial.vue?vue&type=template&id=06c27765&"
import script from "./info_serial.vue?vue&type=script&lang=js&"
export * from "./info_serial.vue?vue&type=script&lang=js&"
import style0 from "./info_serial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports